<template>
  <div>
    <div class="boxed-category">
      <md-subheader>Asset Details</md-subheader>
      <AssetDealerEditor :securityType="securityType" :value="application" :prefixLabel="capitalize(securityType)"></AssetDealerEditor>
      <div class="md-layout input-layout">
        <div class="md-layout-item md-size-10">
          <!-- Condition -->
          <validated-select-input
            label="Condition"
            :prefixLabel="capitalize(securityType)"
            v-model="condition"
            :options="{
            'new': 'New / Demo',
            'used': 'Used',
            'pre_approval': 'Pre-Approval',
          }"
          ></validated-select-input>
        </div>

        <div class="md-layout input-layout">

          <!-- Make -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Make"
            :prefixLabel="capitalize(securityType)"
            v-model="security.make"
            v-if="is_loan_type_marine_leisure_equipment"
          >
          </validated-text-input>
          <!-- Make -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Make"
            :prefixLabel="capitalize(securityType)"
            v-model="security.make"
            :options="all_makers"
            v-if="!is_loan_type_marine_leisure_equipment"
          >
          </validated-autocomplete-input>

          <!-- Model -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Model"
            :prefixLabel="capitalize(securityType)"
            v-model="security.model"
            v-if="is_loan_type_marine_leisure_equipment"
          >
          </validated-text-input>
          <!-- Model -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Model"
            :prefixLabel="capitalize(securityType)"
            v-model="security.model"
            :options="models_make"
            v-if="!is_loan_type_marine_leisure_equipment"
          >
          </validated-autocomplete-input>

          <!-- Model Year -->
          <validated-input
            class="md-layout-item md-small-size-100 md-size-15"
            type="YEAR"
            label="Year"
            :prefixLabel="capitalize(securityType)"
            v-model="security.model_year"
            v-if="is_loan_type_marine_leisure_equipment"
          >
          </validated-input>
          <!-- Model Year -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Year"
            :prefixLabel="capitalize(securityType)"
            v-model="security.model_year"
            :options="options.model_years"
            force
            v-if="!is_loan_type_marine_leisure_equipment"
          >
          </validated-autocomplete-input>

          <!-- NVIC -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-80 "
            v-bind:class="security_nvic_html_class"
            label="NVIC"
            :prefixLabel="capitalize(securityType)"
            v-model="security.nvic"
            readonly
          >
          </validated-autocomplete-input>
          <md-button class="md-just-icon md-simple search-glass-data"
                     @click="fetch_glass_data"
                     v-if="has_glass_search"
          >
            <md-icon>search</md-icon>
          </md-button>

          <!-- Value -->
          <validated-input
            type="CURRENCY"
            class="md-layout-item md-small-size-100 md-size-20"
            label="Glass's Retail Value"
            :prefixLabel="capitalize(securityType)"
            prefix="$"
            v-model="security.value"
            disabled
          />
        </div>
      </div>
      <div class="md-layout input-layout">
        <div class="md-layout-item md-size-10">
        </div>
        <div class="md-layout input-layout">
          <!-- Engine Number -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Engine Number"
            :prefixLabel="capitalize(securityType)"
            v-model="security.engine_number"
            regex = "^[A-Z0-9]*$"
            :maxLength=20
            @input="security.engine_number = security.engine_number.toUpperCase()"
            :errormsg = "'Engine number is not valid.'"
          >
          </validated-text-input>
          <!-- Build Date -->
          <div class="md-layout-item md-small-size-100 md-size-35">
          <validated-mm-yyyy-input
            ref="buildDateInput"
            label="Build Date"
            v-model="security.build_date"
            :prefixLabel="capitalize(securityType)"
            @monthYearSelect="changeMonthYear($event, security.build_date, 'build_date')"
          />
          </div>
          <!-- Compliance Date (MM-YYYY) -->
          <div class="md-layout-item md-small-size-100 md-size-35">
            <validated-mm-yyyy-input
              ref="complianceDateInput"
              label="Compliance Date"
              :prefixLabel="capitalize(securityType)"
              v-model="security.completion_date"
              @monthYearSelect="changeMonthYear($event, security.completion_date, 'completion_date')"
            />
          </div>
        </div>
      </div>

      <div class="md-layout input-layout">
        <div class="md-layout-item md-size-10">
        </div>
        <div class="md-layout input-layout">
          <!-- Registration -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="Registration"
            :prefixLabel="capitalize(securityType)"
            v-model="security.registration"
            alpha-dash
            :maxLength=20
            :errormsg = "'Registration Number is not valid.'"

          >
          </validated-text-input>

          <!-- State -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-50 md-size-10"
            label="State"
            :prefixLabel="capitalize(securityType)"
            v-model="security.state"
            :options="states"
            force
          >
          </validated-autocomplete-input>

          <!-- VIN -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            :label="is_loan_type_equipment ? 'Serial Number' : 'VIN'"
            :prefixLabel="capitalize(securityType)"
            v-model="security.vin"
            :regex="is_loan_type_equipment ? '[A-Za-z0-9]' : '^[A-Za-z0-9]{17}$'"
            :maxLength=17
            :errormsg="is_loan_type_equipment ? 'Serial Number must less than 17 characters' : 'VIN must be 17 characters.'"
            v-if="!is_loan_type_marine"
          >
          </validated-text-input>

          <!-- HIN -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="HIN"
            :prefixLabel="capitalize(securityType)"
            v-model="security.hin"
            regex="^[A-Za-z0-9]{14}$"
            errormsg="HIN must be 14 characters."
            v-if="is_loan_type_marine"
          >
          </validated-text-input>

          <!-- Odometer -->
          <validated-input
            type="POSITIVE_INTEGER"
            class="md-layout-item md-small-size-100 md-size-20"
            label="Odometer"
            :prefixLabel="capitalize(securityType)"
            v-model="security.odometer"
            suffix="km"
          />

          <!-- Description -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-30"
            label="Description"
            :prefixLabel="capitalize(securityType)"
            v-model="security.description"
          >
          </validated-text-input>
        </div>
      </div>
      <AssetValueEditor :securityType="securityType" :value="application" :prefixLabel="capitalize(securityType)"></AssetValueEditor>
    </div>
    <div v-if="glasses.length > 0" v-show="show_glasses">
      <group-card
        title="Possible Existing Vehicle Infomation Match Found"
        icon="fact_check" >
        <template slot="actions">
          <span class="filter-action">
            <validated-text-input
              v-model="search_query"
              label="Filter...."
              class="placeholder"
            />
          </span>
          <md-button class="md-raised md-primary" @click="show_glasses = false">
            <md-icon>cancel</md-icon>
            Close
          </md-button>
        </template>

        <md-table v-model="filtered_glasses" class="">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Variant" md-sort-by="variant">{{ item.variant }}</md-table-cell>
            <md-table-cell md-label="Style">{{ item.style }}</md-table-cell>
            <md-table-cell md-label="Injection">{{ item.injection }}</md-table-cell>
            <md-table-cell md-label="Series">{{ item.series }}</md-table-cell>
            <md-table-cell md-label="Engine CC">{{ item.engineCC }}</md-table-cell>
            <md-table-cell md-label="Transmission">{{ item.transmission }}</md-table-cell>
            <md-table-cell md-label="Cylinders">{{ item.cylinder }}</md-table-cell>
            <md-table-cell md-label="Price" md-sort-by="aAveragePrice">{{ item.aAveragePrice | currency(0) }}</md-table-cell>
            <md-table-cell md-label="NVIC">{{ item.nvic }}</md-table-cell>
            <md-table-cell md-label="Action"><md-button
              class="md-icon-button md-primary md-simple"
              @click="selectVehicle(item)"
            >
              <md-icon>launch</md-icon>
              <md-tooltip md-direction="top">Select Vehicle</md-tooltip>
            </md-button></md-table-cell>
          </md-table-row>
        </md-table>

      </group-card>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import PropertyView from '@/components/ApplicationSummary/PropertyView';
import AssetValueEditor from "./AssetValueEditor";
import ValidatedAutocompleteInput from "../../ValidatedInput/ValidatedAutocompleteInput";
import ValidatedSelectInput from "../../ValidatedInput/ValidatedSelectInput";
import ValidatedMmYyyyInput from "../../ValidatedInput/ValidatedMmYyyyInput.vue";
import AssetDealerEditor from "./AssetDealerEditor";
import moment from "moment";
export default {
  components: {
    AssetDealerEditor,
    ValidatedSelectInput,
    ValidatedAutocompleteInput,
    AssetValueEditor,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    PropertyView,
    ValidatedMmYyyyInput
  },
  props: {
    securityType: {
      type: String,
      required: true,
    },
    value: {
      type:Object,
      required: true
    }
  },
  data(){
    return{
      show_glasses: false,
      security_nvic_html_class: 'md-size-20',
      has_glass_search: false,
      headers: [
        "variant",
        "style",
        "injection",
        "series",
        "engineCC",
        "transmission",
        "cylinder",
        "aAveragePrice",
        "nvic",
      ],
      search_query: "",
      dateFormat: 'MM-YYYY'
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
      all_makers: "all_makers",
      models_make: "models_make",
      glasses: "glasses",
      updating_application: "updating_application",
    }),
    security: {
      get() {
        return this.application.loan.asset[this.securityType];
      },
      set(securityType) {
        this.$emit("input", securityType);
      },
    },
    application: {
      get(){
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      }
    },
    estimated_asset_age: {
      get() {
        // ensure ongoing calculations are Number type, other input may cause infinite set() get() loops
        let make_year = Number.parseInt(
          this.security.make_year
        );

        if (isNaN(make_year)) {
          // if make year is empty, age is empty
          return null;
        } else {
          let age = new Date().getFullYear() - make_year;

          if (age < 0) return 0; // if make is in future, assume 0 / brand new
          if (make_year < 1000) return null; // do not set age if not a >=4 digit number
          return age;
        }
      },
      set(age) {
        // ensure ongoing calculations are Number type, other input may cause infinite set() get() loops
        age = Number.parseInt(age);
        if (isNaN(age)) {
          age = null;
        }

        // only perform an update if the age actually changed
        // NOTE md-input triggeres a set() call everytime its value updates, that both when a user types into it (of course)
        // as well as the variable it v-moeled onto changes. This means everytime we programically change age, set() is called twice
        if (age != this.estimated_asset_age) {
          // if empty, make year should be empty
          if (age == null) {
            this.security.make_year = null;
          } else {
            // calculate make year
            this.security.make_year =
              new Date().getFullYear() - age;
          }
        }
      },
    },
    states(){
      return this.options.country_states[this.options.countries[0]];
    },
    is_loan_type_marine(){
      return this.securityType == "marine";
    },
    is_loan_type_vehicle(){
      return this.securityType == "vehicle";
    },
    is_loan_type_equipment() {
      return this.securityType == "equipment";
    },
    is_loan_type_marine_leisure_equipment() {
      return this.securityType == "leisure" || this.securityType == "equipment" || this.securityType == "marine";
    },
    condition:{
      get(){
        let condition = '';
        if(this.security.new) {
          condition = 'new';
        } else if(!this.security.new && !this.security.pre_approval) {
          condition = 'used';
        }
        if(this.security.pre_approval) {
          condition = 'pre_approval';
        }
        return condition;
      },
      set(vehicle_condition){
        switch(vehicle_condition) {
          case 'new':
            this.security.new = true;
            this.security.pre_approval = false;
            break;
          case 'used':
            this.security.new = false;
            this.security.pre_approval = false;
            break;
          case 'pre_approval':
            this.security.new = true;
            this.security.pre_approval = true;
        }
      }
    },
    filtered_glasses() {
      if (this.search_query !== "") {
        return this.glasses.filter((obj) => {
          return this.headers.some((key) => {
            const value = obj[key];
            if (value !== null) {
              const strValue = typeof value === 'number' ? value.toString() : value;
              return strValue.toLowerCase().includes(this.search_query.toLowerCase());
            }
            return false; // Exclude null values from the comparison
          });
        });
      } else {
        return this.glasses;
      }
    }
  },
  watch:{
    "security.model_year"(after, before) {
      if (!this.is_loan_type_marine_leisure_equipment) {
        this.security_nvic_html_class = 'md-size-15';
        this.has_glass_search = true;
        this.fetch_glass_data();
      }
    },
    "security.make"(after, before) {
      if (!this.is_loan_type_marine_leisure_equipment) {
        this.fetch_model();
      }
    },
    "security.model"(after, before) {
      if (!this.is_loan_type_marine_leisure_equipment) {
        this.security_nvic_html_class = 'md-size-15';
        this.has_glass_search = true;
        this.fetch_glass_data();
      }
    },
    "application.loan.id"() {
      this.$nextTick(() => {
        this.show_glasses = false;
      });
    },
    "updating_application"(after, before) {
      if (before && !after) {
        this.$refs.buildDateInput.refreshValue();
        this.$refs.complianceDateInput.refreshValue();
      }
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,
    /**
     * get make by model year select
     * @returns {Promise<void>}
     */
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    async fetch_make() {
      // fetch data fail or not current make, reset make and model
      let payload = {
        current_make: this.security.make,
      }
      let response = await this.$store.dispatch("load_all_make", payload);
      if (response && response.current_make != false) {
        return;
      }
      if (this.condition != "pre_approval") {
        this.security.make = null;
        this.security.model = null;
      }
    },

    /**
     * get model by model year and make
     *
     * @returns {Promise<void>}
     */
    async fetch_model() {
      if (this.security.make) {
        let payload = {
          make: this.security.make,
          current_model: this.security.model,
        };
        let response = await this.$store.dispatch("load_model_make", payload);
        if (response && response.current_model != false) {
          if (this.security.model != "") {
            this.security_nvic_html_class = 'md-size-15';
            this.has_glass_search = true;
          } else {
            this.security_nvic_html_class = 'md-size-20';
            this.has_glass_search = false;
          }
          return;
        }
        if (this.condition != "pre_approval") {
          this.security.model = null;
        }
      }
    },
    /**
     * get all glass data by model year, make and model
     *
     * @returns {Promise<void>}
     */
    async fetch_glass_data() {
      let payload = {
        year: this.security.model_year,
        make: this.security.make,
        model: this.security.model,
      };
      if (this.security.model_year &&
        this.security.model_year != 0 &&
        this.security.make &&
        this.security.model
      ) {
        this.show_glasses = this.is_loan_type_vehicle;
        if (this.security.model_year) {
          await this.$store.dispatch("load_glass_data", payload);
        }

        this.security_nvic_html_class = 'md-size-15';
        this.has_glass_search = true;
      } else {
        this.security_nvic_html_class = 'md-size-20';
        this.has_glass_search = false
      }
    },
    /**
     * fill up the vehicle value, nvic, variant and series field
     *
     * @param glass
     * @returns {Promise<void>}
     */
    async selectVehicle(glass) {

      let payload = {
        price: glass.aAveragePrice,
        nvic: glass.nvic,
        variant: glass.variant,
        series: glass.series,
        style: glass.style,
        injection: glass.injection,
        transmission: glass.transmission,
      }
      await this.$store.dispatch("set_vehicle_value", payload);
      this.show_glasses = false;
    },

    changeMonthYear(monthYear, date, component) {
      const month = monthYear.month;
      const year = monthYear.year;

      if (!year) {
        this.security[component] = null;
        return;
      }

      date = this.getMomentValue(date)
      if (date !== null) {
        date.month(month ? (parseInt(month) - 1) : 0);
        date.year(parseInt(year))
        this.security[component] = date.format('YYYY-MM-DD')
      }
    },
    getMomentValue(date) {
      let momentDate;
      momentDate = moment(date);
      if(!momentDate.isValid()) {
        momentDate = moment().startOf('month')
      }
      return momentDate;
    },
  },
  mounted() {
    // preload make and model after refresh the page.
    if (!this.is_loan_type_marine_leisure_equipment) {
      this.fetch_make();
      if (this.security.model_year && this.security.make) {
        this.fetch_model();
      }
    }
  },
  async beforeCreate() {
    const params = {
      types: [
        'model_years',
        'country_states',
        'countries',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  filters:{
    ...filters
  }
}
</script>

<style>
.md-button.md-just-icon.search-glass-data {
  margin-top: 20px;
  min-width: 20px;
  width: 20px;
}
.filter-action {
  margin-right: 10px;
  width: 180px;
}
.vue-monthly-picker .picker .flexbox div {
    padding: 5px 0 !important;
}
.vue-monthly-picker .input{
  color: #4a5564 !important;
  border: #efefef !important;
  font-size: 14px !important;
}
.month-year-display{
    background-color: #efefef !important;
}
.vue-monthly-picker .picker .flexbox .item.active.selected {
  background-color: #2E3485 !important;
}
</style>
